export enum ORDER_TYPE {
	ALL = "",
	MARKET = "MARKET",
	LIMIT = "LIMIT",
	STOP = "STOP",
}
